export function extractCssStylesFromStyledComponent(styledComponent) {
  let selectedComponentProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return styledComponent.componentStyle.rules.map(rule => {
    const ruleResult = typeof rule === 'function' ? rule(selectedComponentProps) : rule;
    if (!ruleResult) {
      return '';
    }
    if (Array.isArray(ruleResult)) {
      return ruleResult.join('');
    }
    return ruleResult;
  }).join('');
}